import type * as lazyIndex from './lazyIndex';
import { LazyBootModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule(
    () => import(/* webpackChunkName: "NativeAddAccountSupport" */ './lazyIndex'),
    { name: 'NativeAddAccountSupport' }
);

export const lazyRestoreFromLocalBackup: LazyAction<
    typeof lazyIndex.restoreFromLocalBackup,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.restoreFromLocalBackup);

export const lazyLocalAccountBackup: LazyAction<
    typeof lazyIndex.localAccountBackup,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.localAccountBackup);

export const lazyAddAdditionalAccount: LazyAction<
    typeof lazyIndex.addAdditionalAccount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addAdditionalAccount);

export const lazyCreateAndAddNewConsumerAccount: LazyAction<
    typeof lazyIndex.createAndAddNewConsumerAccount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.createAndAddNewConsumerAccount);

export const lazyRemoveAccount: LazyAction<typeof lazyIndex.removeAccount, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.removeAccount);

export const lazyDisablePendingAccount: LazyAction<
    typeof lazyIndex.disablePendingAccount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.disablePendingAccount);

export const lazyRemovePendingAccount: LazyAction<
    typeof lazyIndex.removePendingAccount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removePendingAccount);

export const lazyRemediateAllLicensingAccounts: LazyAction<
    typeof lazyIndex.remediateAllLicensingAccounts,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.remediateAllLicensingAccounts);

export const lazyRemediateLicensingMailbox: LazyAction<
    typeof lazyIndex.remediateLicensingMailbox,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.remediateLicensingMailbox);

export const lazyDoesSharedMailboxHaveFullAccess: LazyAction<
    typeof lazyIndex.doesSharedMailboxHaveFullAccess,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.doesSharedMailboxHaveFullAccess);

export const lazyReplaceAddedAccount: LazyAction<
    typeof lazyIndex.replaceAddedAccount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.replaceAddedAccount);

export const lazyLoadCloudEnvironmentDiscoverer: LazyAction<
    typeof lazyIndex.loadCloudEnvironmentDiscoverer,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadCloudEnvironmentDiscoverer);
